var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddToKbIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6304 19.5121C12.627 19.4116 12.5509 19.3285 12.451 19.3165C8.05995 19.0906 5.55995 14.196 7.95112 10.5061C9.06087 8.79364 10.9999 7.80322 13.0378 7.90805C14.2384 7.90497 15.4086 8.28464 16.3788 8.99189C16.4439 9.03147 16.5256 9.03147 16.5907 8.99189C16.6607 8.9598 16.7054 8.88955 16.7048 8.81255V5.08855C16.7206 4.30172 16.172 3.61597 15.401 3.4588C15.2112 3.42005 15.075 3.25314 15.075 3.05947V1.82897C15.075 0.928885 14.3454 0.199219 13.4452 0.199219H3.25912C1.90895 0.199219 0.814453 1.29372 0.814453 2.64389V17.3118C0.814453 18.6621 1.90895 19.7566 3.25912 19.7565H12.4266C12.5391 19.7565 12.6304 19.6653 12.6304 19.5528V19.5121ZM2.44429 2.64389C2.44429 2.1938 2.80912 1.82897 3.25912 1.82897H13.2415C13.354 1.82897 13.4452 1.92022 13.4452 2.03272V3.25505C13.4452 3.36755 13.354 3.4588 13.2415 3.4588H3.25912C2.80904 3.4588 2.44429 3.09397 2.44429 2.64389Z",
    fill: "url(#paint0_linear_11126_94344)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 10C13.5523 10 14 10.4477 14 11V17C14 17.5523 13.5523 18 13 18C12.4477 18 12 17.5523 12 17V11C12 10.4477 12.4477 10 13 10Z",
    fill: "#5E6A7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14C9 13.4477 9.44772 13 10 13L16 13C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15L10 15C9.44772 15 9 14.5523 9 14Z",
    fill: "#5E6A7D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11126_94344",
    x1: 15.8437,
    y1: 0.159861,
    x2: -1.65987,
    y2: 16.0817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#ED76AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B0EA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToKbIcon);
export default __webpack_public_path__ + "static/media/add-to-kb-icon.f48aebf0034c9c1c9f9002d1f07e6ce6.svg";
export { ForwardRef as ReactComponent };